import styled from "styled-components";
import { flexBox } from "styles/mixins";

export const BoxOutline = styled.div`
  width: ${({ width }) => width || "auto"};
  height: ${({ height }) => height || "fit-content"};
  border-radius: 8px;
  border: ${({ theme }) => `1px solid ${theme.colors.border.grey}`};
  background: #fff;
  padding: ${({ padding }) => padding || "20px"};
  margin: ${({ margin }) => margin || "0"};
`;

export const BoxColumnWrapper = styled.div`
  ${flexBox("row", "space-between", "center")};
  gap: ${({ gap }) => gap || "0"};
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "100%"};
  margin: ${({ margin }) => margin || "0"};
  & > div {
    width: ${({ count }) => `calc(100% / ${count})`};
  }
`;